/*=========================================================================================
  File Name: moduleLearningHubActions.js
  Description: Learning Hub Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {

  fetchCategories({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/learninghub/categories", {
        logbog_app: '1'
      })
        .then((response) => {
          commit('SET_CATEGORIES', response.data)
          commit('SET_CATEGORIES_COUNT', response.data.length)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  
  createCategory({ commit }, data ) {
    return new Promise((resolve, reject) => {
      axios.post("/api/learninghub/categories/add", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getACategory({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios.post("/api/learninghub/categories/edit/"+id)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateCategory({ commit }, data ) {
    return new Promise((resolve, reject) => {
      axios.post("/api/learninghub/categories/update", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  
  fetchList({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/learninghub/all", {
        logbog_app: '1'
      })
        .then((response) => {
          commit('SET_LIST', response.data)
          commit('SET_LIST_COUNT', response.data.length)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  createListing({ commit }, data ) {
    return new Promise((resolve, reject) => {
      axios.post("/api/learninghub/add", data, {
        headers: { 'content-type': 'multipart/form-data' }
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateListing({ commit }, data ) {
    return new Promise((resolve, reject) => {
      axios.post("/api/learninghub/update", data, {
        headers: { 'content-type': 'multipart/form-data' }
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  fetchCategoriesDD({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/learninghub/categoriesdd", {
        logbog_app: '1'
      })
        .then((response) => {
          commit('SET_CATEGORIES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getAList({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios.post("/api/learninghub/edit/"+id)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

}
